<template>
  <div class="tw-pl-2 tw-pr-4">
    <div class="tw-pb-2">
      <InputGroup
        :label="`Update Date ${dateType}`"
        name="date"
        type="date"
        placeholder="date"
        v-model="date"
        :error="dateError"
      />
    </div>
    <div class="tw-flex tw-items-center tw-justify-end">
      <BaseButton
        text="Cancel"
        class="tw-border-0 tw-bg-app-black-11"
        @click="cancelEditing"
        :disabled="savingDate"
      />
      <BaseButton
        text="Save"
        class="tw-border-0 tw-bg-black tw-text-white tw-ml-2"
        @click="saveProgramDate"
        :disabled="savingDate"
      />
    </div>
  </div>
</template>

<script>
import InputGroup from '@/components/InputGroup.vue';

export default {
  name: 'EditCompanyProgramDate',
  components: {
    InputGroup,
  },
  props: {
    companyProgram: {
      type: Object,
      required: true,
    },
    dateType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      date: this.companyProgram[this.dateType],
      dateError: undefined,
      savingDate: false,
    };
  },
  methods: {
    cancelEditing() {
      this.$emit('cancel-editing');
    },
    async saveProgramDate() {
      // date range validation

      this.savingDate = true;

      const formData = {
        progid: this.companyProgram.id,
        [this.dateType]: this.date,
      };

      let response;

      if (this.dateType === 'start') {
        response = await this.$store.dispatch('editProgramDateStart', formData);
      } else if (this.dateType === 'end') {
        response = await this.$store.dispatch('editProgramDateEnd', formData);
      } else {
        console.error('INVALID DATETYPE');
      }

      if (!response) {
        this.$toasted.global.appError({ errorMessage: 'Could not save new program date' });
      } else {
        this.$toasted.success('Program date saved', {
          duration: 3500,
          position: 'top-right',
        });

        this.$emit('date-saved', this.dateType);
      }

      this.savingDate = false;
    },
  },
};
</script>

<style>

</style>
